"use client";

import Splash from "../Splash";
import ModuleRepeater from "./ModuleRepeater";
import Featured from "../Featured";
import { FeaturedComponent } from "@/types/modules";
import { useLanguageUrl } from "@/context/languageURLContext";
import ModuleContent from "./ModuleContent";
import { useEffect } from "react";

export default function BuyoutComponent({ data }: any) {
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(data.translations[0].uri);
  }, [data.translations, setUrl]);

  const featured: FeaturedComponent = {
    backgroundColor: data.featured.backgroundColor,
    title: data.featured.title,
    custom: data.featured.custom,
  };

  return (
    <>
      {data.slider && data.slider.slider && (
        <Splash slider={data.slider.slider} />
      )}
      <ModuleContent
        title={data.optionsBuyout.title}
        links={data.optionsBuyout.links}
        body={data.optionsBuyout.text}
      />
      <ModuleRepeater modules={data.optionsBuyout.modules} />
      <Featured featured={featured} />
    </>
  );
}
